import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { isOnline, onOnlineChange, lastSync } from "@/lib/offline";

export function useOnline() {
  const [on, setOn] = useState(isOnline());
  useEffect(() => onOnlineChange(() => setOn(isOnline())), []);
  return on;
}

export function OfflineBanner() {
  const on = useOnline();
  if (on) return null;
  const ts = lastSync();
  return (
    <div data-testid="offline-banner" role="status" className="sticky top-0 z-40 bg-[#1F2128] text-white text-xs sm:text-sm px-4 py-2 flex items-center gap-2 justify-center">
      <WifiOff className="h-4 w-4 shrink-0 text-amber-300" />
      <span><b>Offline</b> — showing saved data, editing is paused{ts ? ` · last synced ${new Date(ts).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}` : ""}</span>
    </div>
  );
}
